import styled, { css } from "styled-components";
import { fontSizes } from "healthex-common/sizes";
export const LoadingPlaceholderParent = styled.div `
    padding: ${(props) => props.h}px ${(props) => props.w}px;
    display: block;
    text-align: center;

    ${(props) => props.center &&
    css `
            align-self: center;
        `}
`;
export const LoadingPlaceholderText = styled.div `
    margin-top: 10px;
    font-size: ${fontSizes.STANDARD};
`;
